import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import ToastUGNX from "../ToastsAndAlerts/ToastUGNX";
import styled, { withTheme } from "styled-components";
import { ToastOptions } from "./constants";
import CryptoJS from "crypto-js";
import i18next from "i18next";

const StyledContainer = styled(ToastContainer)`
  .Toastify__toast {
    padding: 0px;
  }
  .Toastify__toast--default {
    color: ${(props) => props.theme.nero};
  }
`;

const titleObj = {
  Success: "appText.success",
  Error: "appText.error",
  Warning: "appText.warning",
};

export const sendNotification = (message, type, cardName = false) => {
  const title = i18next.t(titleObj[type]);

  message &&
    toast(
      <ToastUGNX {...{ type }} {...{ cardName }} {...{ title }}>
        {String(message)}
      </ToastUGNX>,
      { ...ToastOptions, toastId: CryptoJS.MD5(message).toString() }
    );
};

const ToastManager = (props) => {
  return <StyledContainer {...props} />;
};

export default withTheme(ToastManager);
